import { AuthBranch } from "./types";

export const initialState: AuthBranch = {
    token: "",
    refreshToken: "",
    user: null,
};
